/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */
import { globalBreak } from '@/styles/break';
import { SxProps } from '@mui/material';

export const productCardNameSX: SxProps = {
	display:'-webkit-box',
	WebkitLineClamp:3,
	WebkitBoxOrient:'vertical',
	overflow:'hidden', 
	textAlign:'left',
	fontSize:globalBreak({mobile:12, desktop:16}),
	minHeight:'3.5em', // 24316 when 200x zoomed and name has 3 lines, last line is broken.
	lineHeight:1.2,
	wordBreak:'break-word',
	'&:hover':{
		textDecoration:'underline'
	}
};
